module.exports = __webpack_public_path__ + "static/img/42428e3e25aff5ee85120a1f0fbddf2.966015c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/42428e3e25aff5ee85120a1f0fbddf2.png
// module id = ++9y
// module chunks = 20